import React, { useEffect } from "react";
import Footer from "../Footer/Footer";
import "./help.css";
import HelpHeader from "./HelpHeader";
import HelpNav from "./HelpNav";

const Help: React.FC = () => {
  useEffect(() => {
    const faders = document.querySelectorAll('.fade-in');
  
    const appearOptions = {
      threshold: 0.2, // kicsit előbb figyel
      rootMargin: "0px 0px -200px 0px" // előbb elkezdi tölteni
    };
  
    const appearOnScroll = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('show');
        observer.unobserve(entry.target);
      });
    }, appearOptions);
  
    faders.forEach((fader, index) => {
      const el = fader as HTMLElement;
      el.style.transitionDelay = `${index * 0.03}s`; // kicsit lassabb chain effekt
      appearOnScroll.observe(el);
    });
  }, []);
  return (
    <>
    <HelpNav />
    <HelpHeader/>
    <section className="helpo-section">
      <div className="helpo-wrapper">

        {/* 1. blok: bal szöveg - jobb kép */}
        <div id="behavioural-support" className="helpo-block fade-in">
          <div className="helpo-text ">
            <h2 className="helpo-h2 fade-in">Behavioural support</h2>
            <p className="fade-in">
              Understandably, organisations often struggle with understanding adverse behaviour within their workforce. Examples include (but are not limited to),
              bullying, insubordination, absenteeism, intimidation, unethical or illegal conduct, aggression and even violence. At TAG, we can assist organisations by proactively
              developing strategies and processes to identify and reduce such instances of workplace problems. Further, we can undertake comprehensive risk or threat assessments
              of individuals or groups, and subsequently develop tailored and individualised recommendations to manage such situations. Expert consultation with TAG can assist
              you in making your organisation a safer environment.
            </p>
          </div>
          <div className="helpo-image">
            <img src="behavior.png" alt="Behavioural support illustration" />
          </div>
        </div>

        {/* 2. blok: jobb kép - bal szöveg (reverse) */}
        <div id="personality-support" className="helpo-block helpo-reverse fade-in">
          <div className="helpo-text">
            <h2 className="helpo-h2 fade-in">Personality-based support</h2>
            <p className="fade-in">
              Personalities are complex, multifaceted and can have a significant impact on the workforce. Most organisations are aware of this and are implementing strategies
              to enhance organisational engagement and increase staff retention. Strategies include personality-based suitability assessments at recruitment, education and
              mentoring of more established staff and professional assistance to help navigate complex cases. At TAG, we can assist with personality-based issues by providing
              education, pre-screening assessments, personality assessment and consultative advice.
            </p>
          </div>
          <div className="helpo-image">
            <img src="mental-2.png" alt="Personality support illustration" />
          </div>
        </div>

        {/* 3. blok: bal szöveg - jobb kép */}
        <div id="mental-health-support" className="helpo-block fade-in">
          <div className="helpo-text">
            <h2 className="helpo-h2 fade-in">Mental health support</h2>
            <p className="fade-in">
              It is estimated that around 22% of Australian adults have experienced a mental disorder in the previous 12 months. As such, issues associated with mental health
              are highly relevant to all organisations, particularly those with a large and diverse workforce. Unmanaged mental health can result in reduced productivity,
              increased absenteeism and presenteeism, safety risks, staff turnover, impaired team dynamics, low morale and/or a lack of trust in leadership. At TAG, we can assist
              you in promoting a psychologically safe environment to reduce incidents of workplace psychological trauma and distress. We can provide education and strategies to
              manage burnout, promote a healthy work-life balance and give you evidence-based advice on ways to assist those exhibiting concerning psychological symptoms. Employers
              have a duty of care to provide psychologically safe workplaces under Work Health and Safety laws. At TAG, we can help you meet these legislative requirements,
              establish and promote a positive work culture, and adequately support those in psychological need.
            </p>
          </div>
          <div className="helpo-image">
            <img src="mental-h.png" alt="Mental health support illustration" />
          </div>
        </div>
      </div>
    </section>
    <Footer/>
    </>

  );
};

export default Help;
